import { KeyedObject } from 'bernie-core/dist/source';
import { AnalyticsStore } from 'bernie-core';
import { ActivityDetailStore } from '../stores';

function getRecommendationUisPayload(activityDetailStore: ActivityDetailStore): KeyedObject {
  const recommendationPayload =
    activityDetailStore.activityRecommendations &&
    activityDetailStore.activityRecommendations.uisPayload.recommendationPayload;

  return recommendationPayload ? JSON.parse(recommendationPayload) : {};
}

export function trackRecommendationModuleLoad(
  analytics: AnalyticsStore,
  activityDetailStore: ActivityDetailStore
): void {
  let uisPayload: KeyedObject;
  try {
    uisPayload = getRecommendationUisPayload(activityDetailStore);
  } catch (e) {
    uisPayload = {};
  }
  analytics.trackEvent(
    'LX.IS.Recommendations.Load',
    'RFRR Action Link',
    analytics.omnitureData,
    null,
    true,
    uisPayload
  );
}
